(() => {
  const renumberRows = (list) => {
    list.querySelectorAll('[data-rnews-row]').forEach((row, index) => {
      const number = row.querySelector('[data-rnews-index]');
      if (number) number.textContent = String(index + 1).padStart(2, '0');
    });
  };

  const initializeFeed = (feed) => {
    if (!feed || feed.dataset.rnewsInitialized === 'true') return;

    feed.dataset.rnewsInitialized = 'true';

    const list = feed.querySelector('[data-rnews-list]');
    const button = feed.querySelector('[data-rnews-load-more]');
    const status = feed.querySelector('[data-rnews-status]');

    if (!list || !button) return;

    button.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (button.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      const label = button.querySelector('[data-rnews-button-label]');
      const defaultLabel = label ? label.textContent : '';
      const nextUrl = button.href;

      button.setAttribute('aria-busy', 'true');
      if (label && button.dataset.loadingLabel) label.textContent = button.dataset.loadingLabel;

      try {
        const response = await fetch(nextUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextFeed = parsed.getElementById(feed.id) || parsed.querySelector('[data-rnews-feed]');
        const nextList = nextFeed && nextFeed.querySelector('[data-rnews-list]');

        if (!nextList) throw new Error('The next article list was not found');

        const newRows = Array.from(nextList.querySelectorAll('[data-rnews-row]'));
        newRows.forEach((row) => list.appendChild(document.importNode(row, true)));
        renumberRows(list);

        const nextButton = nextFeed.querySelector('[data-rnews-load-more]');
        if (nextButton) {
          button.href = nextButton.href;
          button.removeAttribute('aria-busy');
          if (label) label.textContent = defaultLabel;
        } else {
          const buttonWrap = button.closest('.rbf-load');
          if (buttonWrap) buttonWrap.remove();
        }

        if (status) status.textContent = button.dataset.successLabel || '';
      } catch (error) {
        button.removeAttribute('aria-busy');
        if (label) label.textContent = defaultLabel;
        if (status) status.textContent = button.dataset.errorLabel || '';
      }
    });
  };

  const initializeWithin = (root = document) => {
    if (root.matches && root.matches('[data-rnews-feed]')) initializeFeed(root);
    root.querySelectorAll?.('[data-rnews-feed]').forEach(initializeFeed);
  };

  initializeWithin();

  document.addEventListener('shopify:section:load', (event) => {
    initializeWithin(event.target);
  });
})();
